export const ADD_VOLUME_3DS = 'ADD_VOLUME_3DS';
export const ADD_VOLUME_3DS_BY_SCAN = 'ADD_VOLUME_3DS_BY_SCAN';
export const UPDATE_VOLUME_3D = 'UPDATE_VOLUME_3D';
